export default __webpack_public_path__ + "static/media/Markers_Grey Marker - Boat.a96b72b0.svg";